import React, { useEffect } from "react";
import "./RemplacementElevage.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import Tarifs from "../../sections/Tarifs/Tarifs";
import { remplacementElevageData } from "../../data/remplacementElevageData";
import { soinsData } from "../../data/soinsData";
import Wave from "../../components/Wave/Wave";
import TrustIndexWidget from "../../sections/TrustIndexWidget/TrustIndexWidget";
import Contact from "../../sections/Contact/Contact";
import { Helmet } from "react-helmet";

const RemplacementElevage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    const handleAnimationEnd = (e) => {
      if (e.target.hasAttribute("data-aos")) {
        e.target.removeAttribute("data-aos");
      }
    };

    const elements = document.querySelectorAll("[data-aos]");

    elements.forEach((element) => {
      element.addEventListener("transitionend", handleAnimationEnd);
    });

    return () => {
      elements.forEach((element) => {
        element.removeEventListener("transitionend", handleAnimationEnd);
      });
    };
  }, []);

  return (
    <div id="remplacement-elevage">
      <Helmet>
        <title>Remplacement d'élevage | Pokélu</title>
        <meta
          name="description"
          key="description"
          content="Je vous propose un service de remplacement professionnel et bienveillant, assurant la continuité des soins et du bien-être de vos animaux en votre absence."
        />
        </Helmet>
      <section className="cours-container section-container">
        <h1 className="title">Remplacement d'élevages / pension</h1>
        <div className="flex-container">
          <div className="text-content" data-aos="fade-right">
            <p>
              {" "}
              Gérer un élevage ou une pension demande du temps et une attention
              constante. Mais il est{" "}
              <strong>
                essentiel de prendre une pause et de se ressourcer
              </strong>
              .
            </p>
            <p>
              {" "}
              Je vous propose un service de{" "}
              <strong>remplacement professionnel et bienveillant</strong>,
              assurant la continuité des soins et du bien-être de vos animaux en
              votre absence.{" "}
            </p>
            <p>
              {" "}
              Grâce à mon expérience, je m’adapte aux besoins spécifiques de
              chaque élevage ou pension,{" "}
              <strong>
                garantissant un environnement stable et rassurant
              </strong>{" "}
              tout en respectant vos consignes.{" "}
            </p>
            <p>
              {" "}
              <strong>Partez l’esprit tranquille</strong> : vos animaux sont
              entre de bonnes mains.{" "}
            </p>
          </div>
          <div className="image-container" data-aos="fade-left">
            <img src="/img/rempl-eleva/ludivine.webp" alt="Ludivine Skubisz" />
          </div>
        </div>
      </section>
      <Wave isStart={true} isCanva={false} />
      <section className="soins-container section-container">
        <h2 className="title">Les soins apportés</h2>
        <div className="soins-grid">
          {soinsData.map((soin, index) => (
            <div
              data-aos="fade-up"
              data-aos-duration="700"
              className="soin-card"
              id={soin.title}
              key={index}
            >
              <div>
                <img
                  className="soin-icon"
                  src={"/img/rempl-eleva/" + soin.icon}
                  alt={soin.title}
                />

                <h3 className="soin-title">{soin.title}</h3>
              </div>
              <p className="soin-description">{soin.description}</p>
              {soin.details ? (
                <p className="soin-description">
                  <span className="red">*</span>
                  {soin.details}
                </p>
              ) : (
                <></>
              )}
            </div>
          ))}
        </div>
      </section>
      <Wave isStart={false} isCanva={false} />
      <Tarifs
        isPrix={true}
        isMajoration={true}
        isRempl={true}
        listTarifs={remplacementElevageData}
        accroche="Mon travail respecte l’intégrité de l’animal mais aussi celle de l’humain afin de vous proposez des <strong>services propres</strong> à vos animaux."
      />
      {/* <TrustIndexWidget />  */}
      <Contact isRemplacement={true} />
    </div>
  );
};

export default RemplacementElevage;
